module.exports = __webpack_public_path__ + "img/emoji_72.24dabfa6.png";